import { render, staticRenderFns } from "./ResultLearningObjects.vue?vue&type=template&id=549a6cb1"
import script from "./ResultLearningObjects.vue?vue&type=script&lang=js"
export * from "./ResultLearningObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports